/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { MoonLoader } from "react-spinners";
import Pagination from "../../../../Helper/Pagination";
import { Switch } from "@mui/material";

export default function CanvasSplits() {
  const [SplitList, setSplitList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [error, setError] = useState(false);
  const [size, setsize] = useState("");
  const [thick_price, setthick_price] = useState("");
  const [price, setprice] = useState("");
  const [state, setstate] = useState("");
  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    getSplitList();
  }, [search_key, currentPage]);

  useEffect(() => {
    setsize(selectedData?.size);
    setthick_price(selectedData?.thick_price);
    setprice(selectedData?.price);
  }, [selectedData]);

  const getSplitList = () => {
    setLoading(true); 
    PostService(API_URL.GET_SPLIT_LIST,{searchkey:search_key}).then((res) => {
      if (res?.data?.status === true) {
        setSplitList(res?.data?.data);
        // SetTotalPageCount(res?.data?.totalPages);
        // SetTotalCount(res?.data?.totalItems);
        // setCount(res?.data?.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };
  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "Active" ? "Inactive" : "Active",
    };

    PostService(API_URL.UPDATE_SPLIT_CANVAS, data).then(
      (res) => {
        if (res?.data?.status) {
          showSuccessAlert(`Status ${status === "Active" ? "inactive" : "active"} successfully`, getSplitList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err?.data?.message);
      }
    );
  };

  function resetFunc() {
    setSelectedData("");
    setsize("");
    setthick_price("");
    setprice("");
    setError(false);
    setsubmitLoader(false);
  }

  function UpdateSplit() {
    if (!price || !thick_price) {
      setError(true);
      return;
    }
    setsubmitLoader(true);
    const data = {
      thick_price,
      price,
      id: selectedData?.id,
    };

    PostService(API_URL.UPDATE_SPLIT_CANVAS, data).then((res) => {
      setsubmitLoader(false);
      if (res?.data?.status) {
        document.getElementById("closeEditModal").click();
        showSuccessAlert(res?.data?.message, getSplitList);
      } else {
        showErrorAlert(res.data?.message);
      }
    });
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Split Canvas List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  Split Canvas List
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <div class="card">
        <div className="card-body ">
          <div className="align-items-center d-flex justify-content-end row">
            <div className="col-md-4 p-0">
              <nav className="navbar">
                <input
                  type="text"
                  name="firstnamesearch"
                  placeholder="Search by Keyword"
                  className="form-control"
                  autoComplete="off"
                  onChange={(e) => {
                    setTimeout(() => {
                      setsearch_key(e.target.value);
                      setCurrentPage(0);
                    }, 400);
                  }}
                />
              </nav>
            </div>
          </div>
          <div class="table-responsive mt-3">
            {!loading && (
              <table class="table table-hover table-bordered table-striped">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Size</th>
                    <th>Panels</th>
                    <th>Standard 3/4 ($)</th>
                    <th>Thick 1 1/2 ($)</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {SplitList?.map((item, i) => (
                    <tr>
                      <td>{i + S_No_Count + 1}</td>
                      <td>{item?.size ? item?.size : "N/A"}</td>
                      <td>{item?.panels === 2 ? 'Dyptychs-2 Panels': 'Tryptychs-3 Panels'|| "N/A"}</td>
                      <td>{item?.price ? item?.price : "N/A"}</td>
                      <td>{item?.thick_price ? item?.thick_price : "N/A"}</td>
                      <td className="text-center">
                        <label
                          className={
                            item?.status === "Active"
                              ? "badge badge-success"
                              : "badge badge-danger"
                          }
                        >
                          {" "}
                          {item?.status}
                        </label>
                      </td>
                      <td>
                        <span className="toggle-switch">
                          <Switch
                            checked={item?.status === "Active"}
                            onChange={() => {
                              changeStatus(item?.id, item?.status);
                            }}
                            size="small"
                            color="primary" // You can customize the color
                            inputProps={{
                              "aria-label": "toggle switch",
                            }}
                          />
                        </span>
                        <span
                          title="Edit"
                          style={{ cursor: "pointer" }}
                          className="mx-2"
                          data-toggle="modal"
                          data-target="#AddModal"
                          onClick={() => {
                            setSelectedData(item);
                            setstate("Edit");
                          }}
                        >
                          <i className="text-dark fas fa-pen"></i>
                        </span>
                      </td>
                    </tr>
                  ))}
                  {SplitList && SplitList?.length === 0 && (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <h6 className="p-3"> No Data Found </h6>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
            {loading ? (
              <div className="LoaderSpinner">
                <MoonLoader
                  color={"#003bff"}
                  loading={loading}
                  speedMultiplier={0.6}
                  size={50}
                />
                <div>Loading... Please wait.</div>
              </div>
            ) : (
              ""
            )}
            {/* <div className="mt-4">
              <Pagination
                counting={S_No_Count}
                totaldata={TotalCount}
                pagecount={TotalPageCount}
                onChangePage={handlePageClick}
                activePage={currentPage}
              />
            </div> */}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="AddModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                {state} Split Canvas Size
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="form-group col-md-6 col-12">
                    <label>Size</label>
                    <input
                      type="text"
                      name="ShippingCharge"
                      className="form-control"
                      placeholder="Size"
                      value={size}
                      readOnly
                    />
                  </div>

                  <div className="form-group col-md-6 col-12">
                    <label>Standard 3/4 ($)</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter Standard Price"
                      value={price}
                      onChange={(e) => {
                        setprice(e?.target?.value);
                      }}
                    />
                    {error && !price && (
                      <div className="error mt-1">Standard price is required</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6 col-12">
                    <label>Thick ($)</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter Thick Price"
                      value={thick_price}
                      onChange={(e) => {
                        setthick_price(e?.target?.value);
                      }}
                    />
                    {error && !thick_price && (
                      <div className="error mt-1">Thick is required</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary py-2"
                  onClick={() => {
                    UpdateSplit();
                  }}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : state === "Add" ? (
                    "Add"
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
